/* */ 
"format cjs";
(function(window, factory) {
  if (typeof define == 'function' && define.amd) {
    define(['outlayer/outlayer', 'get-size/get-size', 'desandro-matches-selector/matches-selector', 'fizzy-ui-utils/utils', './item', './layout-mode', './layout-modes/masonry', './layout-modes/fit-rows', './layout-modes/vertical'], function(Outlayer, getSize, matchesSelector, utils, Item, LayoutMode) {
      return factory(window, Outlayer, getSize, matchesSelector, utils, Item, LayoutMode);
    });
  } else if (typeof module == 'object' && module.exports) {
    module.exports = factory(window, require('outlayer'), require('get-size'), require('desandro-matches-selector'), require('fizzy-ui-utils'), require('./item'), require('./layout-mode'), require('./layout-modes/masonry'), require('./layout-modes/fit-rows'), require('./layout-modes/vertical'));
  } else {
    window.Isotope = factory(window, window.Outlayer, window.getSize, window.matchesSelector, window.fizzyUIUtils, window.Isotope.Item, window.Isotope.LayoutMode);
  }
}(window, function factory(window, Outlayer, getSize, matchesSelector, utils, Item, LayoutMode) {
  'use strict';
  var jQuery = window.jQuery;
  var trim = String.prototype.trim ? function(str) {
    return str.trim();
  } : function(str) {
    return str.replace(/^\s+|\s+$/g, '');
  };
  var Isotope = Outlayer.create('isotope', {
    layoutMode: 'masonry',
    isJQueryFiltering: true,
    sortAscending: true
  });
  Isotope.Item = Item;
  Isotope.LayoutMode = LayoutMode;
  var proto = Isotope.prototype;
  proto._create = function() {
    this.itemGUID = 0;
    this._sorters = {};
    this._getSorters();
    Outlayer.prototype._create.call(this);
    this.modes = {};
    this.filteredItems = this.items;
    this.sortHistory = ['original-order'];
    for (var name in LayoutMode.modes) {
      this._initLayoutMode(name);
    }
  };
  proto.reloadItems = function() {
    this.itemGUID = 0;
    Outlayer.prototype.reloadItems.call(this);
  };
  proto._itemize = function() {
    var items = Outlayer.prototype._itemize.apply(this, arguments);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      item.id = this.itemGUID++;
    }
    this._updateItemsSortData(items);
    return items;
  };
  proto._initLayoutMode = function(name) {
    var Mode = LayoutMode.modes[name];
    var initialOpts = this.options[name] || {};
    this.options[name] = Mode.options ? utils.extend(Mode.options, initialOpts) : initialOpts;
    this.modes[name] = new Mode(this);
  };
  proto.layout = function() {
    if (!this._isLayoutInited && this._getOption('initLayout')) {
      this.arrange();
      return;
    }
    this._layout();
  };
  proto._layout = function() {
    var isInstant = this._getIsInstant();
    this._resetLayout();
    this._manageStamps();
    this.layoutItems(this.filteredItems, isInstant);
    this._isLayoutInited = true;
  };
  proto.arrange = function(opts) {
    this.option(opts);
    this._getIsInstant();
    var filtered = this._filter(this.items);
    this.filteredItems = filtered.matches;
    this._bindArrangeComplete();
    if (this._isInstant) {
      this._noTransition(this._hideReveal, [filtered]);
    } else {
      this._hideReveal(filtered);
    }
    this._sort();
    this._layout();
  };
  proto._init = proto.arrange;
  proto._hideReveal = function(filtered) {
    this.reveal(filtered.needReveal);
    this.hide(filtered.needHide);
  };
  proto._getIsInstant = function() {
    var isLayoutInstant = this._getOption('layoutInstant');
    var isInstant = isLayoutInstant !== undefined ? isLayoutInstant : !this._isLayoutInited;
    this._isInstant = isInstant;
    return isInstant;
  };
  proto._bindArrangeComplete = function() {
    var isLayoutComplete,
        isHideComplete,
        isRevealComplete;
    var _this = this;
    function arrangeParallelCallback() {
      if (isLayoutComplete && isHideComplete && isRevealComplete) {
        _this.dispatchEvent('arrangeComplete', null, [_this.filteredItems]);
      }
    }
    this.once('layoutComplete', function() {
      isLayoutComplete = true;
      arrangeParallelCallback();
    });
    this.once('hideComplete', function() {
      isHideComplete = true;
      arrangeParallelCallback();
    });
    this.once('revealComplete', function() {
      isRevealComplete = true;
      arrangeParallelCallback();
    });
  };
  proto._filter = function(items) {
    var filter = this.options.filter;
    filter = filter || '*';
    var matches = [];
    var hiddenMatched = [];
    var visibleUnmatched = [];
    var test = this._getFilterTest(filter);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.isIgnored) {
        continue;
      }
      var isMatched = test(item);
      if (isMatched) {
        matches.push(item);
      }
      if (isMatched && item.isHidden) {
        hiddenMatched.push(item);
      } else if (!isMatched && !item.isHidden) {
        visibleUnmatched.push(item);
      }
    }
    return {
      matches: matches,
      needReveal: hiddenMatched,
      needHide: visibleUnmatched
    };
  };
  proto._getFilterTest = function(filter) {
    if (jQuery && this.options.isJQueryFiltering) {
      return function(item) {
        return jQuery(item.element).is(filter);
      };
    }
    if (typeof filter == 'function') {
      return function(item) {
        return filter(item.element);
      };
    }
    return function(item) {
      return matchesSelector(item.element, filter);
    };
  };
  proto.updateSortData = function(elems) {
    var items;
    if (elems) {
      elems = utils.makeArray(elems);
      items = this.getItems(elems);
    } else {
      items = this.items;
    }
    this._getSorters();
    this._updateItemsSortData(items);
  };
  proto._getSorters = function() {
    var getSortData = this.options.getSortData;
    for (var key in getSortData) {
      var sorter = getSortData[key];
      this._sorters[key] = mungeSorter(sorter);
    }
  };
  proto._updateItemsSortData = function(items) {
    var len = items && items.length;
    for (var i = 0; len && i < len; i++) {
      var item = items[i];
      item.updateSortData();
    }
  };
  var mungeSorter = (function() {
    function mungeSorter(sorter) {
      if (typeof sorter != 'string') {
        return sorter;
      }
      var args = trim(sorter).split(' ');
      var query = args[0];
      var attrMatch = query.match(/^\[(.+)\]$/);
      var attr = attrMatch && attrMatch[1];
      var getValue = getValueGetter(attr, query);
      var parser = Isotope.sortDataParsers[args[1]];
      sorter = parser ? function(elem) {
        return elem && parser(getValue(elem));
      } : function(elem) {
        return elem && getValue(elem);
      };
      return sorter;
    }
    function getValueGetter(attr, query) {
      if (attr) {
        return function getAttribute(elem) {
          return elem.getAttribute(attr);
        };
      }
      return function getChildText(elem) {
        var child = elem.querySelector(query);
        return child && child.textContent;
      };
    }
    return mungeSorter;
  })();
  Isotope.sortDataParsers = {
    'parseInt': function(val) {
      return parseInt(val, 10);
    },
    'parseFloat': function(val) {
      return parseFloat(val);
    }
  };
  proto._sort = function() {
    var sortByOpt = this.options.sortBy;
    if (!sortByOpt) {
      return;
    }
    var sortBys = [].concat.apply(sortByOpt, this.sortHistory);
    var itemSorter = getItemSorter(sortBys, this.options.sortAscending);
    this.filteredItems.sort(itemSorter);
    if (sortByOpt != this.sortHistory[0]) {
      this.sortHistory.unshift(sortByOpt);
    }
  };
  function getItemSorter(sortBys, sortAsc) {
    return function sorter(itemA, itemB) {
      for (var i = 0; i < sortBys.length; i++) {
        var sortBy = sortBys[i];
        var a = itemA.sortData[sortBy];
        var b = itemB.sortData[sortBy];
        if (a > b || a < b) {
          var isAscending = sortAsc[sortBy] !== undefined ? sortAsc[sortBy] : sortAsc;
          var direction = isAscending ? 1 : -1;
          return (a > b ? 1 : -1) * direction;
        }
      }
      return 0;
    };
  }
  proto._mode = function() {
    var layoutMode = this.options.layoutMode;
    var mode = this.modes[layoutMode];
    if (!mode) {
      throw new Error('No layout mode: ' + layoutMode);
    }
    mode.options = this.options[layoutMode];
    return mode;
  };
  proto._resetLayout = function() {
    Outlayer.prototype._resetLayout.call(this);
    this._mode()._resetLayout();
  };
  proto._getItemLayoutPosition = function(item) {
    return this._mode()._getItemLayoutPosition(item);
  };
  proto._manageStamp = function(stamp) {
    this._mode()._manageStamp(stamp);
  };
  proto._getContainerSize = function() {
    return this._mode()._getContainerSize();
  };
  proto.needsResizeLayout = function() {
    return this._mode().needsResizeLayout();
  };
  proto.appended = function(elems) {
    var items = this.addItems(elems);
    if (!items.length) {
      return;
    }
    var filteredItems = this._filterRevealAdded(items);
    this.filteredItems = this.filteredItems.concat(filteredItems);
  };
  proto.prepended = function(elems) {
    var items = this._itemize(elems);
    if (!items.length) {
      return;
    }
    this._resetLayout();
    this._manageStamps();
    var filteredItems = this._filterRevealAdded(items);
    this.layoutItems(this.filteredItems);
    this.filteredItems = filteredItems.concat(this.filteredItems);
    this.items = items.concat(this.items);
  };
  proto._filterRevealAdded = function(items) {
    var filtered = this._filter(items);
    this.hide(filtered.needHide);
    this.reveal(filtered.matches);
    this.layoutItems(filtered.matches, true);
    return filtered.matches;
  };
  proto.insert = function(elems) {
    var items = this.addItems(elems);
    if (!items.length) {
      return;
    }
    var i,
        item;
    var len = items.length;
    for (i = 0; i < len; i++) {
      item = items[i];
      this.element.appendChild(item.element);
    }
    var filteredInsertItems = this._filter(items).matches;
    for (i = 0; i < len; i++) {
      items[i].isLayoutInstant = true;
    }
    this.arrange();
    for (i = 0; i < len; i++) {
      delete items[i].isLayoutInstant;
    }
    this.reveal(filteredInsertItems);
  };
  var _remove = proto.remove;
  proto.remove = function(elems) {
    elems = utils.makeArray(elems);
    var removeItems = this.getItems(elems);
    _remove.call(this, elems);
    var len = removeItems && removeItems.length;
    for (var i = 0; len && i < len; i++) {
      var item = removeItems[i];
      utils.removeFrom(this.filteredItems, item);
    }
  };
  proto.shuffle = function() {
    for (var i = 0; i < this.items.length; i++) {
      var item = this.items[i];
      item.sortData.random = Math.random();
    }
    this.options.sortBy = 'random';
    this._sort();
    this._layout();
  };
  proto._noTransition = function(fn, args) {
    var transitionDuration = this.options.transitionDuration;
    this.options.transitionDuration = 0;
    var returnValue = fn.apply(this, args);
    this.options.transitionDuration = transitionDuration;
    return returnValue;
  };
  proto.getFilteredItemElements = function() {
    return this.filteredItems.map(function(item) {
      return item.element;
    });
  };
  return Isotope;
}));
